export default __webpack_public_path__ + "static/media/ribboncuttin.dd28c1f5.jpeg";